import { invokeApi } from "../../../bl_libs/invokeApi";
import { s3baseUrl } from "src/config/config";

export const MAX_ATTACHMENTS = 5;
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

/**
 * Upload one email attachment (any file type) to S3.
 * Returns { name, path, url, size } or throws with the API message.
 */
export const uploadEmailAttachment = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await invokeApi({
    path: "/app/upload_any_single_file_on_s3",
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: formData,
  });
  if (res?.code !== 200 || !res.path) {
    throw new Error(res?.message || "Could not upload the file");
  }
  return {
    name: file.name,
    path: res.path,
    url: `${s3baseUrl || ""}${res.path}`,
    size: file.size,
  };
};
